import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FeatureCard1 } from "./FeatureCard1";
import { FeatureCard2 } from "./FeatureCard2";

export const featureCardBlocks: BlockExportMapping = {
  FeatureCard1,
  FeatureCard2,
};
